export const SITE_URL = "https://uuuux.design";

export const NAV_LINKS = [
  { label: "Basketball", path: "/basketball" },
  { label: "Classic", path: "/classic" },
  { label: "AI", path: "/ai" },
  { label: "Tennis", path: "/tennis" },
  { label: "Soccer", path: "/soccer" },
] as const;

export const APP_STORE_URL = {
  classic: "#", // TODO: replace with actual App Store URL
  ai: "#", // TODO: replace with actual App Store URL
} as const;

export const PRICING = {
  classic: "Free",
  ai: "$10/month",
} as const;

export const ZONE_COUNT = 19;

export const SOCIAL_LINKS = {
  discord: "https://discord.gg/shootcreator", // TODO: replace with actual invite link
  x: "https://x.com/ShootCreatorApp", // TODO: create account
  tiktok: "https://tiktok.com/@shootcreator", // TODO: create account
  threads: "https://threads.net/@shootcreator", // TODO: create account
  github: "https://github.com/johntips/ShootCreator",
} as const;

export const ROADMAP_URL = {
  classic: "https://shootcreator.canny.io/classic", // TODO: create Canny board
  ai: "https://shootcreator.canny.io/ai", // TODO: create Canny board
} as const;
